// eslint-disable-next-line no-unused-vars

import PmAppSnackbar from "../../components/core/app-snackbar";
import PmAppNotification from "../../components/core/app-notification";
import PmAppNavigationDrawer from "../../components/core/app-navigation-drawer";

const appCoreMixin = {
    components: {
        PmAppNavigationDrawer,
        PmAppSnackbar,
        PmAppNotification,
    },

    data: function() {
        return {
            notification: {
                active: false,
            },
        };
    },

    created() {
        this.initResizeWatcher();
    },

    methods: {
        initResizeWatcher: function() {
            const self = this;
            self.windowWidth = window.innerWidth;
            self.windowHeight = window.innerHeight;
            (function() {
                const throttle = function(type, name, obj) {
                    obj = obj || window;
                    let running = false;
                    const func = function() {
                        if (running) {
                            return;
                        }
                        running = true;
                        requestAnimationFrame(function() {
                            obj.dispatchEvent(new CustomEvent(name));
                            running = false;
                        });
                    };
                    obj.addEventListener(type, func);
                };

                /* init - you can init any event */
                throttle("resize", "optimizedResize");
            })();

            // handle event
            window.addEventListener("optimizedResize", function() {
                if (window.innerWidth !== self.windowWidth || window.innerHeight !== self.windowHeight) {
                    self.windowWidth = window.innerWidth;
                    self.windowHeight = window.innerHeight;
                    self.handleResize();
                }
            });
        },


        handleResize: function() {
            if (this.$vuetify.breakpoint.lgAndUp) {
                this.$root.sidebarVisible = true;
            } else {
                this.$root.sidebarVisible = false;
            }
            this.$nextTick(function() {
                // this.$bus.$emit('resize');
            });
            window.setTimeout(() => {
                this.$bus.$emit("resize");
                if (this.$vuetify.breakpoint.lgAndUp) {
                    this.$root.sidebarVisible = true;
                } else {
                    this.$root.sidebarVisible = false;
                }
            }, 250);
        },

        showSnackbar: function(params) {
            this.$bus.$emit("app.showSnackbar", params);
        },

        /**
         * Show main notification modal
         * @param params
         * color: info / warning / error / succcess
         */
        showNotification: function(params) {
            this.$bus.$emit("app.showNotification", params);
        },
    },
};

export default appCoreMixin;
